<h2 class="reset-h text-lg font-semibold text-default">{{ 'Start from the contract you already use' | translate }}</h2>
<p class="reset-p text-support">
  {{
    'We’ll read it, find everything that changes from contract to contract, like names, dates, pay and clauses, and turn it into fields that fill in automatically. You review every change before the template is created.'
      | translate
  }}
</p>

<p class="reset-p flex flex-wrap items-center gap-xs text-support">
  {{ 'Want to see how it works first?' | translate }}
  <button
    type="button"
    class="reset-button cursor-pointer text-brand hover:underline disabled:cursor-default disabled:text-disabled"
    [disabled]="isLoadingSample() || isUploading()"
    (click)="trySample()"
  >
    {{ 'Try it with a sample contract' | translate }}
  </button>
</p>

@if (sampleFailed()) {
  <sb-notice variant="danger">{{ 'The sample contract couldn’t be loaded. Try again.' | translate }}</sb-notice>
} @else if (rejectedFile()) {
  <sb-notice variant="danger">{{ 'Only .docx files are supported.' | translate }}</sb-notice>
} @else if (rejection(); as rejection) {
  <sb-notice variant="danger">
    @switch (rejection) {
      @case ('too_large') {
        {{ 'Your document is larger than 5MB. Make it smaller and try again.' | translate }}
      }
      @case ('banned_type') {
        {{ 'Only .docx files are supported.' | translate }}
      }
      @case ('dangerous') {
        {{ 'Your document can’t be uploaded because it may be unsafe.' | translate }}
      }
      @default {
        {{ 'Your document couldn’t be uploaded. Try again.' | translate }}
      }
    }
  </sb-notice>
}

<sb-upload
  class="w-full"
  [allowedTypes]="docxTypes"
  [multiple]="false"
  [isUploading]="isUploading() || isLoadingSample()"
  [hasError]="rejectedFile() || rejection() !== null"
  (uploadResult)="handleUpload($event)"
>
  {{ 'Word (.docx)' | translate }}
</sb-upload>

<p class="reset-p flex flex-wrap items-center gap-xs text-support">
  {{ 'Prefer to add placeholders yourself?' | translate }}
  <button type="button" class="reset-button cursor-pointer text-brand hover:underline" (click)="setUpManually.emit()">
    {{ 'Set up manually' | translate }}
  </button>
</p>
